
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1201_DtGrid extends Serenity.EntityGrid<Report_1201_DtRow, any> {
        protected getColumnsKey() { return Report_1201_DtColumns.columnsKey; }
        protected getDialogType() { return Report_1201_DtDialog; }
        protected getIdProperty() { return Report_1201_DtRow.idProperty; }
        protected getInsertPermission() { return Report_1201_DtRow.insertPermission; }
        protected getLocalTextPrefix() { return Report_1201_DtRow.localTextPrefix; }
        protected getService() { return Report_1201_DtService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}